<template>
  <div id="app">
    <el-container>
      <!-- 侧边栏 -->
      <el-aside width="200px" style="background-color: #304156;">
        <div class="logo">
          <h2 style="color: white; text-align: center; padding: 20px 0;">投标管理系统</h2>
        </div>

        <el-menu
          :default-active="$route.path"
          class="sidebar-menu"
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
          router>
          <el-menu-item index="/statistics">
            <i class="el-icon-data-line"></i>
            <span slot="title">数据统计</span>
          </el-menu-item>
          <el-menu-item index="/projects">
            <i class="el-icon-office-building"></i>
            <span slot="title">项目管理</span>
          </el-menu-item>
          <el-menu-item index="/packages">
            <i class="el-icon-box"></i>
            <span slot="title">包管理</span>
          </el-menu-item>
          <el-menu-item index="/bid-records">
            <i class="el-icon-document"></i>
            <span slot="title">投标记录</span>
          </el-menu-item>
          <el-menu-item index="/import">
            <i class="el-icon-upload"></i>
            <span slot="title">数据导入</span>
          </el-menu-item>
          <el-menu-item index="/bidder-analysis">
            <i class="el-icon-s-data"></i>
            <span slot="title">投标人分析</span>
          </el-menu-item>
          <el-menu-item index="/help">
            <i class="el-icon-question"></i>
            <span slot="title">帮助手册</span>
          </el-menu-item>
        </el-menu>
      </el-aside>

      <!-- 主内容区 -->
      <el-container>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.el-container {
  height: 100vh;
  flex: 1;
}

.el-aside {
  height: 100vh;
  overflow-y: auto;
  background-color: #304156 !important;
}

.sidebar-menu {
  border-right: none;
  height: calc(100vh - 80px);
}

.logo {
  border-bottom: 1px solid #434a50;
}

.el-main {
  padding: 20px;
  overflow-y: auto;
}
</style>
